import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

import { guidMatch } from 'ui-components/services/guid-service';

import { OrdersLeftNav } from './orders-left-nav';
import { OrdersLeftNavContextProvider } from './orders-left-nav/orders-left-nav-context';
import { OrdersPageStateManager } from './orders-page-state-manager';
import { ActiveSubscriptionRequired } from '../../components/active-subscription-required';
import Page from '../../components/page';
import ToggleLeftNav from '../../components/toggle-left-nav';
import { FiltersContextProvider } from '../../filters/context';
import AlertsPage from '../../pages/alerts';
import OrdersBatches from '../../pages/orders-batches';
import { UserHasRoleAndSubscription } from '../../role-based-route';
import { OrdersGridViewService } from '../../services/orders-grid-view-service';
import { UserPermissionService, DEFAULT_ORDERS_PAGE_URL } from '../../services/user-permission-service';
import style from '../grid-page.module.less';

import { OrdersPageLoader } from './index';

const OrdersPageRouter = () => {
  return (
    <Page>
      <FiltersContextProvider>
        <OrdersLeftNavContextProvider>
          <OrdersPageStateManager>
            <div className={style['grid-page']}>
              <ToggleLeftNav>
                <OrdersLeftNav />
              </ToggleLeftNav>
              <Switch>
                <Route path='/orders/alerts/:alertFilter(shiptogether|custom)?/:alertId?'>
                  <ActiveSubscriptionRequired>
                    <AlertsPage />
                  </ActiveSubscriptionRequired>
                </Route>
                <Route path='/orders/batches/:tabFilter(open|active|archived)?/:batchId?'>
                  <ActiveSubscriptionRequired>
                    <OrdersBatches />
                  </ActiveSubscriptionRequired>
                </Route>
                <Route path={`/orders/:statusViewId${OrdersGridViewService.getRouteFilter()}/(store)?/:storeGuid(${guidMatch})?`}>
                  <UserHasRoleAndSubscription requiredPermissionRole={UserPermissionService.orderManagementPermissionRole}>
                    <OrdersPageLoader />
                  </UserHasRoleAndSubscription>
                </Route>
                <Route path='*'>
                  <Redirect to={DEFAULT_ORDERS_PAGE_URL} />
                </Route>
              </Switch>
            </div>
          </OrdersPageStateManager>
        </OrdersLeftNavContextProvider>
      </FiltersContextProvider>
    </Page>
  );
};

export { OrdersPageRouter };
